import { createIdMapFromList } from 'util/ImmutableCollectionOperations';
import DomainObjectView from 'domain/DomainObjectView';
import { Holiday } from 'domain/Holiday';
import { Map } from 'immutable';
import { ActionType, HolidayList, HolidayAction } from './types';

export const initialState: HolidayList = {
  isLoading: true,
  holidayMapById: Map<number, DomainObjectView<Holiday>>(),
};
// eslint-disable-next-line default-param-last
const holidayReducer = (state = initialState, action: HolidayAction): HolidayList => {
  switch (action.type) {
    case ActionType.SET_HOLIDAY_LIST_LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case ActionType.ADD_HOLIDAY:
    case ActionType.UPDATE_HOLIDAY: {
      return { ...state, holidayMapById: state.holidayMapById.set(action.holiday.id as number, action.holiday) };
    }
    case ActionType.REMOVE_HOLIDAY: {
      return { ...state, holidayMapById: state.holidayMapById.remove(action.holiday.id as number) };
    }
    case ActionType.REFRESH_HOLIDAY_LIST: {
      return { ...state, holidayMapById: createIdMapFromList(action.holidayList) };
    }
    default:
      return state;
  }
};

export default holidayReducer;
